<template>
	<div
		class="load-more-card"
		@click="handleClick"
	>
		<span class="load-more-text">{{ lang }}</span>
		<span class="load-more-text-after"></span>
		<img
			class="load-more-background"
			src="/api/images/product-list/button-background.jpg"
			alt="Load more button background"
		>
		<svg
			class="load-more-icon"
			width="307"
			height="383"
			viewBox="0 0 307 383"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M57.7261 136.013C84.1349 90.7456 121.61 52.9289 166.635 26.1101C215.034 -2.34719 266.744 -13.5361 311.973 -2.98588C418.623 21.9586 444.194 153.269 356.291 274.798L390.686 290.789C499.039 144.446 465.496 -12.7437 334.836 -38.5989C280.772 -49.2438 219.93 -34.4829 163.785 -0.182732C112.477 31.4844 69.8455 75.4084 39.7244 127.639C-17.9708 227.878 -13.1806 341.92 56.4605 395.404L73.6224 368.662C11.3854 323.705 6.40596 223.939 57.7261 136.013ZM107.745 315.461C61.9131 286.283 57.2175 215.743 94.7347 153.21C113.493 121.796 140.24 95.9145 172.253 78.199C186.665 69.4542 202.666 63.6515 219.333 61.1261C236 58.6006 253.003 59.4025 269.358 63.4854C284.625 68.0749 298.204 77.056 308.403 89.3094C318.601 101.563 324.968 116.546 326.71 132.393C331.096 173.026 319.852 213.805 295.26 246.447L326.012 260.77C359.638 213.306 374.222 160.626 366.368 114.817C363.839 94.6812 355.314 75.7707 341.899 60.5421C328.485 45.3136 310.801 34.4707 291.144 29.4218C253.769 19.4038 210.397 27.695 169.32 50.9836C130.407 73.3626 97.9673 105.456 75.1718 144.126C30.2386 220.107 35.1944 306.07 89.8972 343.315L107.757 315.473L107.745 315.461ZM181.514 163.666C172.8 167.724 165.435 174.2 160.294 182.322C155.153 190.445 152.452 199.873 152.513 209.486C154.18 226.766 170.053 234.892 188.398 227.227C197.702 223.37 205.62 216.785 211.109 208.34C216.598 199.895 219.402 189.986 219.15 179.917C217.009 162.069 199.965 154.937 181.55 163.583M228.624 126.917C236.184 129.828 242.771 134.813 247.627 141.299C252.483 147.784 255.411 155.508 256.076 163.583C257.867 183.926 252.293 204.237 240.368 220.817L268.14 233.721C286.359 208.97 294.784 178.357 291.795 147.769C290.631 135.748 286.029 124.316 278.538 114.841C271.048 105.367 260.987 98.2506 249.559 94.3438C237.15 90.8404 224.161 89.8779 211.372 91.514C198.582 93.15 186.255 97.3509 175.127 103.865C149.823 117.339 128.633 137.405 113.801 161.939C99.7126 183.745 92.756 209.393 93.895 235.329C94.2336 246.113 97.2242 256.647 102.602 266.001C107.98 275.354 115.58 283.238 124.73 288.956L143.323 259.966C136.846 256.212 131.423 250.883 127.556 244.473C123.689 238.063 121.505 230.78 121.205 223.3C120.266 205.126 125.151 187.127 135.15 171.921C145.55 154.949 160.437 141.18 178.167 132.133C185.776 127.853 194.186 125.187 202.871 124.302C211.556 123.416 220.331 124.331 228.647 126.988" fill="white" fill-opacity="0.1"/>
			<path d="M362.571 336.147L200.781 252.266L99.891 405.836L362.571 336.147Z" fill="white" fill-opacity="0.1"/>
		</svg>

	</div>
</template>

<script>

export default {
	components: {
	},
	computed: {
		lang () {
			const langs = this.$app.translator.get('products')
			return langs?.products_list.load_more_products_button
		}
	},
	methods: {
		handleClick () {
			this.$emit('loadMoreProducts')
		}
	},
	async prefetch () {
		await this.$app.translator.prefetch('products')
	}
}
</script>

<style lang="scss" scoped>
.load-more-card {
	position: relative;
	border-radius: 10px;
	overflow: hidden;
	background-color: #2092DD;
	box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.25) inset;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	cursor: pointer;
	padding: 20px;

	&:hover {
		.load-more-background {
			opacity: 1;
		}

		.load-more-text {
			transform: translateY(-10px);
		}
	}
}

.load-more-text {
	transition: all .3s linear;
	position: relative;
	color: #FFF;
	text-align: center;
	font-size: 24px;
	font-weight: 700;
	text-transform: uppercase;
	z-index: 1;

	@include media-breakpoint-up(xl) {
		font-size: 56px;

	}
}

.load-more-text-after {
	display: block;
	position: relative;
	height: 3px;
	background-color: #fff;
	margin: 10px auto 0 auto;
	z-index: 1;
	width: 200px;

	@include media-breakpoint-up(xl) {
		width: 60%;
		height: 6px;
	}
}

.load-more-icon {
	position: absolute;
	right: 0;
	bottom: 0;
	z-index: 1;
}

.load-more-background {
	transition: opacity .3s linear;
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	opacity: .34;
	z-index: 0;
}
</style>
